import { inherits as _inherits, createClass as _createClass, extends as _extends, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FieldGroup } from './FieldGroup.js';
import { Form } from './Form.js';
import { AvailableLanguagesField } from './AvailableLanguagesField.js';

var MultilingualForm = /*#__PURE__*/function (_React$Component) {
  function MultilingualForm(props) {
    var _this;

    _classCallCheck(this, MultilingualForm);

    _this = _callSuper(this, MultilingualForm, [props]);

    _defineProperty(_this, "onLanguageChange", function (language) {
      if (_this.props.onLanguageChange) {
        _this.props.onLanguageChange(language);
      }

      _this.setState({
        activeLanguage: Object.keys(language)[0].toLowerCase()
      });
    });

    _this.state = {
      activeLanguage: _this.props.activeLanguage || 'en'
    };
    return _this;
  }

  _inherits(MultilingualForm, _React$Component);

  return _createClass(MultilingualForm, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Form, _extends({}, this.props, {
        ref: this.props.formRef,
        activeLanguage: this.state.activeLanguage
      }), /*#__PURE__*/React.createElement(FieldGroup, {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement(FieldGroup, {
        className: "form-setup-translate row"
      }, /*#__PURE__*/React.createElement(FieldGroup, {
        className: "col-9"
      }, this.props.children), /*#__PURE__*/React.createElement(FieldGroup, {
        className: "col-3"
      }, /*#__PURE__*/React.createElement(AvailableLanguagesField, {
        languages: this.props.languages,
        onLanguageChange: this.onLanguageChange
      })))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (props.errorMessage) {
        return {
          isDisabled: false
        };
      }

      return null;
    }
  }]);
}(React.Component);

_defineProperty(MultilingualForm, "propTypes", {
  activeLanguage: PropTypes.string,
  children: PropTypes.any,
  errorMessage: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.object).isRequired,
  onLanguageChange: PropTypes.func,
  formRef: PropTypes.node
});

MultilingualForm.displayName = "MultilingualForm";
export { MultilingualForm };